import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RocketImage from "../assets/images/rocket.svg";
import SellTicketIcon from "../assets/icons/ticket-pink-icon.svg";
import FriendsGroupIcon from "../assets/icons/friends-group-icon.svg";
import RefsGroupIcon from "../assets/icons/ref-group.svg";
import EarningsIcon from "../assets/icons/earnings-icon.svg";
import MainButton from "../components/MainButton";
import { sharingIcons } from "../constants/const";
import { Modal } from "antd";
import { addressToHisReferrer, getUserInfo } from "../web3";

function Friends(data: any) {
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const [shareReferral, setShareReferral] = useState("");
    const [myOwner, setMyOwner] = useState("");
    const [userData, setUserData] = useState<any>([])
    const [referrerAddress, setReferrerAddress] = useState<any>()
    const [totalRewards, setTotalRewards] = useState<any>(0)
    const [soldBonus, setSoldBonus] = useState<any>(0)
    const [refBouns, setRefBonus] = useState<any>(0)

    const { t } = useTranslation();

    useEffect(() => {


        let refCode = data?.address;
        setShareReferral(refCode);
        getUserInfo(data?.address).then((res) => {
            setUserData(res)
            setSoldBonus(res?.soldRewards)
            setRefBonus(res?.referralRewards)
        })
        addressToHisReferrer(refCode).then((res: any) => {
            setReferrerAddress(res)
        });
        setMyOwner(data?.referralId)


    }, [data?.address, userData?.referralsCount, soldBonus])


    const handleOpenShareModal = () => {
        setShareModalOpen(true)
    };

    const handleShareReferral = (socialName: string) => {
        const shareMessage = `Привет! Мой реферальный код: ${shareReferral}. Присоединяйтесь ко мне!`;
        const referralUrl = `https://cryptolottery777.com/${shareReferral}`;

        switch (socialName) {
            case 'WhatsApp':
                window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareMessage + ' ' + referralUrl)}`, "_blank");
                break;
            case 'Facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralUrl)}`, "_blank");
                break;
            case 'X': // Twitter (X)
                window.open(`https://x.com/intent/tweet?text=${encodeURIComponent(shareMessage)}&url=${encodeURIComponent(referralUrl)}`, "_blank");
                break;
            case 'Gmail':
                window.location.href = `mailto:?subject=${encodeURIComponent("Присоединяйтесь ко мне!")}&body=${encodeURIComponent(shareMessage + ' ' + referralUrl)}`;
                break;
            case 'Telegram':
                window.open(`https://t.me/share/url?url=${encodeURIComponent(referralUrl)}&text=${encodeURIComponent(shareMessage)}`, "_blank");
                break;
            case 'Instagram':
                window.open("https://www.instagram.com/", "_blank");
                break;
            case 'YouTube':
                window.open("https://www.youtube.com/", "_blank");
                break;
            case 'Discord':
                window.open("https://discord.com/", "_blank");
                break;
            default:
                console.log(`Социальная сеть ${socialName} не поддерживается.`);
        }
    };


    return (
        <div className="friends">
            <div className="friends_header">
                <div className="friends_header__top">
                    <div className="friends_header__top___title">
                        {t('Реферальная программа')}
                    </div>
                    <img src={RocketImage} alt="icon" className="friends_header__top___logo" />
                </div>
                <div className="friends_header__content">
                    {t('Каждый участник, который приглашает нового игрока, получает 5% от суммы их покупки. Кроме того, если вы продали не менее 5 билетов, вы получаете 10% от суммы покупки каждого приглашенного игрока.')}
                </div>
            </div>
            <div className="friends_identifier">
                <div className="friends_identifier__title">
                    {t('Ваш идентификатор')}
                </div>
                <div className="friends_identifier__content">
                    <span>{shareReferral?.slice(0, 5) + "..." + shareReferral?.slice(-5)}</span>
                </div>
            </div>
            <MainButton
                text={'Поделиться моим кодом'}
                func={handleOpenShareModal}
            />
            <div className="friends_friends-group">
                <div className="friends_friends-group__title">
                    {t('Друзья')}
                </div>
                <div className="friends_friends-group__item">
                    <div className="friends_friends-group__item___info">
                        <img src={FriendsGroupIcon} alt="" width={32} height={32} />
                        <span>{t('Мои друзья')}</span>
                    </div>
                    <div className="friends_friends-group__item___count">
                        {userData?.referralsCount}
                    </div>
                </div>
                {/*<div className="friends_friends-group__item">*/}
                {/*    <div className="friends_friends-group__item___info">*/}
                {/*        <img src={EarningsIcon} alt="" width={32} height={32} />*/}
                {/*        <span>{t('Заработок от друзей')}</span>*/}
                {/*    </div>*/}
                {/*    <div className="friends_friends-group__item___count">*/}
                {/*        {userData?.referralRewards / 10 ** 18}$*/}
                {/*    </div>*/}
                {/*</div>*/}


                {/*start New Item*/}
                <div className="friends_friends-group">
                    <div className="friends_friends-group__title flex-style">
                        <span>{t('Заработок от друзей')}</span>
                        {/* <span>$ {342}</span> */}
                    </div>

                    <div className="friends_friends-group__item">
                        <div className="friends_friends-group__item___info">
                            <img src={RefsGroupIcon} alt="" width={32} height={32} />
                            <div>
                                <span>{t('От привлечение рефералов')}</span>
                                {/* <div className="friends-card-subtitle"> +5% {t('от покупки одного билета')}</div> */}
                            </div>
                        </div>
                        <div className="friends_friends-group__item___count">
                            {refBouns / 10**18} $
                        </div>
                    </div>
                    <div className="friends_friends-group__item">
                        <div className="friends_friends-group__item___info">
                            <img src={SellTicketIcon} alt="" width={32} height={32} />
                            <div>
                                <span>{t('От продажы билетов')}</span>
                                {/* <div className="friends-card-subtitle"> 10% {t('от суммы покупки')}</div> */}
                            </div>
                        </div>
                        <div className="friends_friends-group__item___count">
                            {soldBonus / 10**18} $
                        </div>
                    </div>

                </div>
            </div>
            {/*end new Item*/}

            <div className="friends_identifier">
                <div className="friends_identifier__title">
                    {t('Ваш пригласитель')}
                </div>
                <div className="friends_identifier__content">
                    <span>{referrerAddress?.slice(0, 5) + "..." + referrerAddress?.slice(-5)}</span>
                </div>
            </div>

            <Modal
                open={shareModalOpen}
                footer={null}
                onCancel={() => setShareModalOpen(false)}
                className="share-modal"
                title={t("Поделиться")}
            >
                <div className="share-modal_content">
                    {t('Поделитесь своим реферальным идентификатором в социальных сетях')}
                </div>
                <div className="share-modal_icons-group">
                    {sharingIcons.map((item: any, index) => {
                        return (
                            <div className="share-modal_icons-group__item" key={index}
                                onClick={() => handleShareReferral(item.name)}>
                                <img src={item.icon} alt="icon" width={48} height={48} />
                                <span>{item.name}</span>
                            </div>
                        )
                    })}
                </div>
            </Modal>
        </div>
    )
}

export default Friends
